import { render, staticRenderFns } from "./modalRedesSociales.vue?vue&type=template&id=4c8d4eea&scoped=true&"
import script from "./modalRedesSociales.vue?vue&type=script&lang=js&"
export * from "./modalRedesSociales.vue?vue&type=script&lang=js&"
import style0 from "./modalRedesSociales.vue?vue&type=style&index=0&id=4c8d4eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d4eea",
  null
  
)

export default component.exports